<template>
  <div>
    <div class="container" style="background-color: white; text-align: left;">
      <div class="row no-margin">
        <h5 class="overview-h5">{{ $t('user_detail') }}</h5>
        <small
          class="clear-filter"
          style="height: 24px; margin-top: 16px;"
          v-if="showSaveButton"
          v-on:click="saveUser()"
        >{{ $t('save_2') }}</small>
      </div>

      <div style="margin-top: 8px;">
        <b-alert variant="warning" v-model="showError" dismissible>{{errorMessage}}</b-alert>

        <div class="row">
          <div class="col-sm-6">
            <dl class="row" style="margin-bottom: 0;">
              <dt class="col-sm-5">{{ $t('email') }}</dt>
              <dd class="col-sm-7">
                <input v-model="user.user" class="form-control form-control-sm" />
              </dd>

              <dt class="col-sm-5">{{ $t('role') }}</dt>
              <dd class="col-sm-7">
                <multiselect
                  class="filter-multiselect"
                  v-model="user.role"
                  label="name"
                  track-by="roleId"
                  placeholder
                  :showLabels="false"
                  :options="roles"
                  :searchable="false"
                ></multiselect>
              </dd>

              <dt class="col-sm-5">{{ $t('create_call') }}</dt>
              <dd class="col-sm-7">
                <b-form-checkbox switch size="lg" v-model="user.canCreateCall"></b-form-checkbox>
              </dd>
            </dl>
          </div>
        </div>

        <div style="max-height: 650px;">
          <h5 class="detail-h5">{{ $t('site_overview') }}</h5>
          <div style="padding-top: 0.25rem; padding-bottom: 0.75rem;">
            <input
              v-model="searchCustomerFilter"
              class="form-control form-control-sm"
              :placeholder="$t('search')"
              style="width: 250px;"
            />
          </div>
          <b-table-simple hover small caption-top responsive ref="table" style="max-height: 411px;">
            <b-tbody>
              <b-tr v-for="customer in filteredCustomers" v-bind:key="customer.customerId">
                <b-td style="width: 32px;">
                  <b-form-checkbox
                    v-bind:id="customer.customerId"
                    v-model="customer.selected"
                    value="true"
                    unchecked-value
                  />
                </b-td>
                <b-td
                  style="text-align: left; padding: 8px 12px 7px 12px; line-height: 25px;"
                >{{customer | filterCustomerName}}</b-td>
              </b-tr>
            </b-tbody>

            <b-tfoot>
              <b-tr>
                <b-td colspan="7" class="text-left">
                  <b-button size="sm" @click="selectAllCustomers()">{{ $t('select_all') }}</b-button>
                  <b-button size="sm" @click="deselectAllCustomers()">{{ $t('deselect_all') }}</b-button>
                </b-td>
              </b-tr>
            </b-tfoot>
          </b-table-simple>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserDetail',
  components: {},
  data: function() {
    return {
      roles: [
        { roleId: 1, name: 'Service User' },
        { roleId: 2, name: 'Super User' },
        { roleId: 3, name: 'Admin' },
        { roleId: 4, name: 'Facturen User' }
      ],
      user: {
        loginKey: -1,
        companies: [],
        customers: [],
        role: { roleId: 1, name: 'Service User' }
      },
      customers: [],
      searchCustomerFilter: '',
      errorMessage: '',
      showError: false,
      showSaveButton: false
    };
  },
  filters: {
    filterCustomerName: function(customer) {
      if (!customer) return '';

      if (customer.customerId.startsWith('**')) return customer.customerName;
      if (customer.customerId.startsWith('*A')) return customer.customerName;

      return customer.customerId + ' - ' + customer.customerName;
    }
  },
  methods: {
    saveUser: function() {
      var self = this;

      var user = this.user;

      var selectedCustomers = [];
      this.customers.forEach(item => {
        if (item.selected) {
          selectedCustomers.push(item);
        }
      });

      user.selectedCustomers = selectedCustomers;

      user.roleId = user.role.roleId;
      user.role = null;

      var promise = '';

      if (user.loginKey < 0) {
        promise = this.$axios.post('logins/add', user, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      } else {
        promise = this.$axios.post('logins/edit', user, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      }

      promise
        .then(data => {
          self.errorMessage = '';
          self.showError = false;

          self.$router.go(-1);
        })
        .catch(error => {
          if (error.response.status === 409) {
            var message = self.$t('the_email_address_already_exists', { user: self.user.user });

            self.user.role = self.roles[0];

            self.errorMessage = message;
            self.showError = true;
          }
        });
    },
    selectAllCustomers: function() {
      // First de-select everything so that it works...
      this.customers.forEach(item => {
        item.selected = false;
      });

      this.customers.forEach(item => {
        item.selected = true;
      });
    },
    deselectAllCustomers: function() {
      this.customers.forEach(item => {
        item.selected = false;
      });
    }
  },
  created() {
    // bus.$on('languageChanged', this.changeLanguageHandler);

    let companyId = this.$route.params.companyId;
    let salesGroupId = this.$route.params.salesGroupId;
    let loginKey = this.$route.params.loginKey;

    getUser(this, loginKey, salesGroupId, companyId);
  },
  // beforeDestroy() {
  //   bus.$off('languageChanged', this.changeLanguageHandler);
  // },
  changeLanguageHandler() {},
  computed: {
    filteredCustomers() {
      return this.customers.filter(customer => {
        return (
          customer.customerId
            .toLowerCase()
            .includes(this.searchCustomerFilter.toLowerCase()) ||
          customer.customerName
            .toLowerCase()
            .includes(this.searchCustomerFilter.toLowerCase())
        );
      });
    }
  },
  watch: {
    user: {
      handler: function(after, before) {
        if (after.loginKey === before.loginKey) {
          this.showSaveButton = true;
        }
      },
      deep: true
    },
    customers: {
      handler: function(after, before) {
        if (after.length === before.length) {
          this.showSaveButton = true;
        }
      },
      deep: true
    }
  }
};

function getUser(context, loginKey, salesGroupId, companyId) {
  if (loginKey < 0) {
    context.user.companyId = companyId;
    context.user.salesGroupId = salesGroupId;
    context.user.role = context.roles[0];
    context.user.roleId = context.roles[0].roleId;

    getSalesGroupCustomers(context, salesGroupId);
  } else {
    let promise = context.$axios.get('logins?loginKey=' + loginKey);

    return promise
      .then(data => {
        context.user = data.data;

        getSalesGroupCustomers(context, salesGroupId);
      })
      .catch(error => {
        console.log(error);
      });
  }
}

function getSalesGroupCustomers(context, salesGroupId) {
  let promise = context.$axios.get(
    'customers/GetSalesGroupCustomers?salesGroupId=' + salesGroupId
  );

  return promise
    .then(data => {
      data.data.forEach(item => {
        item.selected = false;
      });

      data.data.forEach(customer => {
        context.user.customers.forEach(userCustomer => {
          if (userCustomer.customerId === customer.customerId) {
            customer.selected = true;
          }
        });
      });

      context.customers = data.data;
    })
    .catch(error => {
      console.log(error);
    });
}
</script>

<style>
.multiselect {
  min-height: 28px !important;
}
table.b-table > thead > tr > th.sorting:focus {
  outline: none !important;
}
.page-item.active .page-link {
  background-color: #18385f;
  border-color: #18385f;
}
.page-link:focus {
  box-shadow: none;
}
</style>

<style scope>
.vc-text-base {
  font-size: 12px;
  padding: 0.25rem 0.5rem;
  height: 28px;
}

.td-user-delete {
  padding: 3px !important;
}

.row-user-delete {
  display: none;
  float: right;
  margin-right: 3px;
}

.table-hover tbody tr:hover .row-user-delete {
  display: block;
}

.alert-dismissible,
.alert-dismissible .close {
  padding: 0.5rem 0.75rem;
}

.custom-control-label {
  cursor: pointer;
}
</style>
